import React from 'react';
import RestCreate from 'containers/rest/Create';
import Form from '../components/Form';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
import crudSelectors from '@redux/crudSelectors';
import _, { flatten, omit } from 'lodash';

const breadcrumbs = [
  {
    title: 'Roles',
    href: '/rolePermissions',
  },
  {
    title: 'common.page.create',
  },
];

const Create = () => {
  const dataPermissions = useSelector<DynamicObjectType[]>(
    crudSelectors.rolePermissionGroups.getDataRecordArr,
  );
  const formatRoles = flatten(
    dataPermissions?.map((item) => {
      const sub = flatten(
        item?.subRolePermissionGroups?.map((subItem) => {
          if (subItem?.rolePermissions?.length > 0)
            return subItem?.rolePermissions;
        }),
      );
      return sub;
    }),
  )?.filter((item) => !!item);

  return (
    <RestCreate
      model="roles"
      breadcrumbs={breadcrumbs}
      hasSelectFilter={false}
      formatOnSubmit={(values) => {
        const role = _.values(values?.rolePermissions);

        return {
          ...omit(values, 'rolePermissions'),
          rolePermissions: formatRoles
            ?.filter((item: DynamicObjectType) =>
              flatten(role)?.includes(item?.id),
            )
            ?.map((item: DynamicObjectType) => ({
              id: Number(item?.id),
            })),
        };
      }}
      customPathAfterSubmit="rolePermissions"
    >
      <Form />
    </RestCreate>
  );
};

export default Create;
